module.exports = __webpack_public_path__ + "static/img/icon-twitter.5e50007c.png";